module.exports = __webpack_public_path__ + "static/media/sioc-BN.176e0db8.svg";